<div id="bannerContainer" 
  *ngIf="dao?.PolicyTemplate == '' && dao?.PolicySubTemplate != 'dot' && dao?.PolicySubTemplate != 'registration' && siteBanner?.enabled" 
    style="padding:2px;text-align: center;"
    [class.critical]="siteBanner.severity.toLowerCase()=='critical'"
    [class.warning]="siteBanner.severity.toLowerCase()=='warning'"
    [class.info]="siteBanner.severity.toLowerCase()=='info'">    
      <h5>
        <marquee>{{siteBanner.text}}</marquee>
      </h5>
</div>